import { IListaPaginada } from '../interfaces';
export abstract class ComponenteComPaginacao {
  obterDadosPaginacao(dados: IListaPaginada) {
    return `${dados.itensPorPagina * (dados.paginaAtual - 1) + 1} - ${
      dados.itensPorPagina * dados.paginaAtual -
      (dados.itensPorPagina - dados.registros.length)
    }
  de ${dados.totalDeItens}`;
  }
}
